/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberSeven(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M112.001,240a8.00547,8.00547,0,0,1-7.59082-10.53164L164.90043,47.99985H80A7.99993,7.99993,0,1,1,80,32h96a8,8,0,0,1,7.58984,10.52969l-64,191.99819A8.00469,8.00469,0,0,1,112.001,240Z" />
    </Svg>
  );
}

export default NumberSeven;
